/**
 * Commits typed date input text: blank text clears to `emptyValue`, text that
 * parses commits the parsed value, and unparseable text keeps the last value.
 */
export const commitDateInputValue = <TValue>({
    inputValue,
    parseValue,
    emptyValue,
    onValueChange,
}: {
    inputValue: string;
    parseValue: (value: string) => TValue | undefined;
    emptyValue: TValue;
    onValueChange: (value: TValue) => void;
}) => {
    if (inputValue.trim().length === 0) {
        onValueChange(emptyValue);
        return;
    }
    const parsedValue = parseValue(inputValue);
    if (parsedValue !== undefined) {
        onValueChange(parsedValue);
    }
};
